import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import React, { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import DataTable from "@components/DataTable/index";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import {
  adminDeleteSpecificOrganization,
  clientAdminFileUpload,
} from "@services/client-list.service";
import Notfound from "@components/Not-Found";
import moment from "moment";
import Loader from "@components/common/Loader";
import FilterForm from "@components/common/AddFilter/FilterForm";
import {
  adminGetCountriesListManagement,
  adminGetLegislationManagement,
  adminGetLegislationManagementRule,
  adminGetListManagementStateCategoryList,
  adminGetStatesListManagement,
} from "@services/list-management.service";
import { UpdateBulkStatusCheckpointPEComplianceTask } from "@services/checkpoint.service";
import { useParams } from "react-router-dom";
import { formatText } from "@_common/format-text";
import TaskLicenseNavigation from "@components/Tasks/task-license-navigation";
import { getSpecificLicenseHistoryTask } from "@services/license.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { NavLink } from "react-router-dom";
import ScrollableReactTable from "@components/ScrollableDatatable";
import ShowCauseNoticeNavigation from "@components/Tasks/show-cause-notice";
import {
  createShowCauseNoticeDetail,
  getShowCauseNoticeDetails,
} from "@services/causenotice.service";
import ShowCauseNoticePopup from "./CauseNoticePopup";
import { todayDate } from "@_common/date-helpers";
import { convertCurrentDate } from "@_common/date-helpers";
import ReportsNotfoundNoLink from "@components/Page-Not-Found/reports-not-found-nolink";
import { removeNullOrUndefinedProperties } from "@_common/text-helpers";

interface IComplianceTaskHistoryProps {}

const ShowCauseNoticeHistory: React.FunctionComponent<IComplianceTaskHistoryProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let mainParams = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      show_cause_notice_id: mainParams.id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getShowCauseNoticeDetails(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.result`, []).map((item: object) => ({
            ...item,
            remainder_date: getValue(item, `remainder_date`, "")
              ? convertCurrentDate(getValue(item, `remainder_date`, ""))
              : "",
            next_due_date: getValue(item, `next_due_date`, "")
              ? convertCurrentDate(getValue(item, `next_due_date`, ""))
              : "",
            status: formatText(getValue(item, `status`, "")),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificOrganization(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.status = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/configuration/vendors/add/${id}`);
  };
  const rowClick = (obj: object) => {
    // navigate(
    //   `/activities/task/license/list/detail/${getValue(obj, `original.id`, "")}/${getValue(
    //     obj,
    //     `original.license.checkpoint.id`,
    //     ""
    //   )}/${getValue(obj, `original.license.location.id`, "")}/${getValue(
    //     obj,
    //     `original.license.license_type.id`,
    //     ""
    //   )}`
    // );
  };

  // id={mainParams.id}
  // 					checkpoint_id={mainParams.checkpoint_id}
  // 					locationId={mainParams.locationId}
  // 					license_type_id={mainParams.license_type_id}
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        width: 80,
        Cell: ({ row }: any) => {
          return (
            // <NavLink
            //   to={`/activities/task/license/list/detail/${row.original.id}/${getValue(
            //     row,
            //     `original.license.checkpoint.id`,
            //     ""
            //   )}/${getValue(
            //     row,
            //     `original.license.location.id`,
            //     ""
            //   )}/${getValue(row, `original.license.license_type.id`, "")}`}
            // >
            <>{row.values.id}</>
            // </NavLink>
          );
        },
      },
      {
        Header: "Action Taken",
        accessor: "action_taken",
        width: 200,
      },
      {
        Header: "Next Action Taken",
        accessor: "next_action_taken",
        width: 200,
      },
      {
        Header: "Comments",
        accessor: "comments",
        width: 350,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 100,
      },
      {
        Header: "Next Due Date",
        accessor: "next_due_date",
        width: 150,
      },
      {
        Header: "Remainder Date",
        accessor: "remainder_date",
        width: 150,
      },

      // 		 {
      //   	Header: "Action",
      //   	width: 170,
      //   	Cell: ({ row }: any) => {
      //   		return (
      //   			<>
      //   				<Button
      //   					color="primary"
      //   					onClick={() => handleEdit(row.original.id)}
      //   				>
      //   					Edit
      //   				</Button>
      //   			</>
      //   		);
      //   	},
      //   },
    ],
    []
  );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await UpdateBulkStatusCheckpointPEComplianceTask({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState({
    next_due_date: "",
    remainder_date: "",
    show_cause_notice: 0,
    status: "OPEN",
    action_taken: "",
    next_action_taken: "",
    comments: "",
    document_id: "",
  });

  const reset = () => {
    setRequest({
      ...request,
      next_due_date: "",
      remainder_date: "",
      show_cause_notice: 0,
      status: "OPEN",
      action_taken: "",
      next_action_taken: "",
      comments: "",
      document_id: "",
    });
  };
  const [noticeList] = useState([
    { value: "OPEN", label: "Open" },
    { value: "REPLY_SENT", label: "Reply Sent" },
    { value: "CLOSED", label: "Closed" },
  ]);
  /* ---------------------------  Update Modal  ----------------------------- */

  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const handleOpenPopup = () => {
    setShowUpdatePopup(!showUpdatePopup);
  };
  // ----------------- Upload section ----------------- //
  const [uploadedDocuments, setUploadedDocuments] = useState<any>([]);
  const [uploadLoading, setUploadLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    e.preventDefault();
    Array.from(e.target.files).forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      // formData.append("domain_name", getValue(localStorage,`client`,''));
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
          setUploadLoading(false);
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
        setUploadLoading(false);
      }
    });
  };
  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
          setUploadLoading(false);
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
        setUploadLoading(false);
      }
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => {};
  const handleRemoveUploadedFiles = (id: string) => {
    let filtered = uploadedDocuments.filter(
      (item: object) => getValue(item, `id`, "") !== id
    );
    setUploadedDocuments(filtered);
  };

  const [submitLoading, setsSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    let obj = JSON.parse(JSON.stringify(request));
    let document_ids = uploadedDocuments.map((item: object) => ({
      id: getValue(item, `id`, ""),
    }));
    let payload: any = {
      show_cause_notice: parseInt(getValue(mainParams, `id`, "")),
      next_due_date: getValue(obj, `next_due_date`, "")
        ? todayDate(getValue(obj, `next_due_date`, ""))
        : null,
      remainder_date: getValue(obj, `remainder_date`, "")
        ? todayDate(getValue(obj, `remainder_date`, ""))
        : null,
      comments: getValue(obj, `comments`, ""),
      action_taken: getValue(obj, `action_taken`, false),
      next_action_taken: getValue(obj, `next_action_taken`, ""),
      document_id: getValue(document_ids, `[${0}].id`, ""),
      status: getValue(obj, `status`, ""),
    };
    let payloadNew: any = {
      show_cause_notice: parseInt(getValue(mainParams, `id`, "")),
      next_due_date: getValue(obj, `next_due_date`, "")
        ? todayDate(getValue(obj, `next_due_date`, ""))
        : null,
      remainder_date: getValue(obj, `remainder_date`, "")
        ? todayDate(getValue(obj, `remainder_date`, ""))
        : null,
      comments: getValue(obj, `comments`, ""),
      action_taken: getValue(obj, `action_taken`, false),
      next_action_taken: getValue(obj, `next_action_taken`, ""),
      status: getValue(obj, `status`, ""),
    };

    try {
      setsSubmitLoading(true);
      let resp = await createShowCauseNoticeDetail(
        document_ids.length > 0
          ? removeNullOrUndefinedProperties(payload)
          : payloadNew
      );
      if (resp) {
        setsSubmitLoading(false);
        toast.success(getValue(resp, `message`, ""));
        setShowUpdatePopup(false);
        getData();
        reset();
      } else {
        setsSubmitLoading(false);
      }
    } catch (error) {
      setsSubmitLoading(false);
    }
  };

  return (
    <Layout>
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "report_show_cause_notice"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="show-cause-notice-history-main-wrap">
            <ShowCauseNoticeNavigation
              id={mainParams.id}
              save={true}
              permissions={props.permissions}
              handleSubmit={handleOpenPopup}
              //search
              isTaskHistorySearch={true}
              isSearch={true}
              searchInput={search_text}
              showSearchTextbox={showSearchTextbox}
              toggleSearch={toggleSearch}
              toggleSearchClose={toggleSearchClose}
              handleChangeSearch={handleChangeSearch}
            />
            {/* {getValue(selectedIDs, `length`, 0) > 0 && (
				<NavigationBar
					selectedIDs={selectedIDs}
					isMarkInactiveSectionVisible={true}
					handleChangeActiveStatus={handleChangeActiveStatus}
					text={"MARK INACTIVE"}
					multi={true}
					handleRemoveNavItems={handleRemoveNavItems}
				/>
			)} */}
            <div className="main-page-layout-wrapper">
              <div className="admin-wrapper position-relative">
                <div className="admin-wrapper position-relative d-none">
                  <SearchHeader
                    route={"/configuration/vendors/add"}
                    searchInput={search_text}
                    showSearchTextbox={showSearchTextbox}
                    toggleSearch={toggleSearch}
                    toggleSearchClose={toggleSearchClose}
                    handleChangeSearch={handleChangeSearch}
                    isBulkUploadVisible={false}
                    smartFilter={false}
                    setFilterFormVisibility={() => {
                      setFilterVisibility(!isFilterVisible);
                    }}
                    isFilterVisible={isFilterVisible}
                    add="false"
                  />
                </div>

                {isLoading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : list.length > 0 ? (
                  <ScrollableReactTable
                    columns={columns}
                    data={list}
                    getTableState={getTableState}
                    rowClick={rowClick}
                    check={check}
                    selectedIDs={selectedIDs}
                    getTrProps={getTrProps}
                  />
                ) : (
                  <>
                    {Object.keys(params).length !== 0 ? (
                      <>
                        <ReportsNotfoundNoLink />
                      </>
                    ) : (
                      <ReportsNotfoundNoLink />
                    )}
                  </>
                )}
              </div>
              {totalCount != 0 && (
                <div className="footer-wrapper d-flex justify-content-between">
                  {list.length > 0 && (
                    <img
                      src="/images/building-illustration.svg"
                      className="img-fluid"
                    />
                  )}
                  {totalCount > 10 ? (
                    <PaginationPage
                      totalCount={totalCount}
                      limit={limit}
                      pageNumber={page_no}
                      handleChangePagination={handleChangePagination}
                      handleChangeLimit={handleChangeLimit}
                    />
                  ) : (
                    <p className="show-rows-count mt-3 d-flex">
                      Total Count:&nbsp;&nbsp;{" "}
                      <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                    </p>
                  )}
                </div>
              )}
              <DeleteModal
                isOpen={isDelete}
                handleModal={handleDelete}
                handleSubmit={handleDeleteFunction}
                deleteValue={deleteValue}
              />
              <ShowCauseNoticePopup
                showUpdatePopup={showUpdatePopup}
                setShowUpdatePopup={setShowUpdatePopup}
                noticeList={noticeList}
                request={request}
                setRequest={setRequest}
                handleDrop={handleDrop}
                uploadLoading={uploadLoading}
                handleDragOver={handleDragOver}
                disableUpload={disableUpload}
                handleUploadDocuments={handleUploadDocuments}
                uploadedDocuments={uploadedDocuments}
                handleRemoveUploadedFiles={handleRemoveUploadedFiles}
                handleSubmit={handleSubmit}
                submitLoading={submitLoading}
              />
            </div>
          </div>
        </>
      )}
    </Layout>
  );
};

export default ShowCauseNoticeHistory;
